import Brands from '../components/Brands';
import OurService from '../components/OurService';
import WorkingProcess from '../components/WorkingProcess';
import AboutHome from '../components/AboutHome';
import Banner from '../components/Banner';
import axios from 'axios';
import { useEffect, useState } from 'react';


const Home = () => {

  const [homeInfo, setHomeInfo] = useState([]);

  const fetchHomeInfo = async () => {
    try {
      const response = await axios.get('https://thecfagroup.org/v1/api/home-info', {
        headers: {
          'accept': '*/*'
        }
      });
      setHomeInfo(response.data);
    } catch (error) {
      console.error('Error fetching home info:', error);
    }
  };


  useEffect(() => {
    fetchHomeInfo();
  }, []);


  return (
    <div>
      <Banner/>
      <div className='bg-[#f8f9fc] pt-10'>
      <Brands/>
      </div>
      <OurService/>
      <WorkingProcess data={homeInfo[0]}/>
      <AboutHome data={homeInfo[1]}/>
    </div>
  );
};

export default Home;
